import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud, FiX } from "react-icons/fi";
import { toast } from "react-toastify";

const MeetingForm = ({
  initialData = null,
  onSubmit,
  onCancel,
  requireImage = true, // yangi qo‘shganda majburiy
}) => {
  const [form, setForm] = useState({
    title: "",
    startTime: "",        // API: startTime
    endTime: "",          // API: endTime (qo'shimcha)
    location: "",
    description: "",
  });

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  // initialData bo‘lsa to‘ldirish
  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        startTime: initialData.startTime
          ? initialData.startTime.split("T")[0]
          : "",
        endTime: initialData.endTime
          ? initialData.endTime.split("T")[0]
          : "",
        location: initialData.location || "",
        description: initialData.description || "",
      });
      setPreview(initialData.imageUrl || null);
      setImage(null);
    } else {
      setForm({ title: "", startTime: "", endTime: "", location: "", description: "" });
      setImage(null);
      setPreview(null);
    }
  }, [initialData]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Rasm hajmi 5MB dan oshmasligi kerak!");
      return;
    }

    setImage(file);
    setPreview(URL.createObjectURL(file));
    toast.success("Rasm tanlandi");
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setImage(null);
    setPreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.title.trim()) return toast.error("Sarlavha majburiy!");
    if (!form.startTime) return toast.error("Boshlanish sanasi majburiy!");
    if (!form.location.trim()) return toast.error("Joylashuv majburiy!");

    if (requireImage && !image && !preview) {
      return toast.error("Tadbir rasmi majburiy!");
    }

    onSubmit({
      ...form,
      image, // yangi fayl yoki null (update bo‘lsa eski saqlanadi)
    });
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="banner-form"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="form-grid">
        {/* Sarlavha */}
        <div className="form-item">
          <label>Sarlavha *</label>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Masalan: Yangi yil bazmi 2026"
            required
          />
        </div>

        {/* Boshlanish sanasi */}
        <div className="form-item">
          <label>Boshlanish sanasi *</label>
          <input
            type="date"
            name="startTime"
            value={form.startTime}
            onChange={handleChange}
            required
          />
        </div>

        {/* Tugash sanasi */}
        <div className="form-item">
          <label>Tugash sanasi</label>
          <input
            type="date"
            name="endTime"
            value={form.endTime}
            onChange={handleChange}
          />
        </div>

        {/* Joylashuv */}
        <div className="form-item">
          <label>Joylashuv *</label>
          <input
            name="location"
            value={form.location}
            onChange={handleChange}
            placeholder="Masalan: Hilton mehmonxonasi yoki Google Maps link"
            required
          />
        </div>

        {/* Rasm yuklash */}
        <div className="form-item">
          <label>Rasm {requireImage ? "*" : "(ixtiyoriy)"}</label>
          <div className="image-upload-box">
            {preview ? (
              <div className="image-preview-wrapper">
                <img
                  src={preview}
                  alt="Tadbir rasmi"
                  className="image-preview-small"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "cover",
                    borderRadius: 14,
                  }}
                />
                <motion.button
                  type="button"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  className="remove-image-btn"
                  onClick={removeImage}
                  title="Rasmni o‘chirish"
                >
                  <FiX size={18} />
                </motion.button>
              </div>
            ) : (
              <motion.label
                htmlFor="meetingImage"
                className="upload-area"
                whileHover={{ scale: 1.02, backgroundColor: "#f0f7ff" }}
                whileTap={{ scale: 0.98 }}
              >
                <FiUploadCloud size={44} color="#00c853" />
                <p>Rasm yuklash</p>
                <span>JPG, PNG • Maks 5MB</span>
              </motion.label>
            )}
            <input
              id="meetingImage"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImage}
            />
          </div>
        </div>

        {/* Izoh */}
        <div className="form-item full-width">
          <label>Izoh (ixtiyoriy)</label>
          <textarea
            name="description"
            rows="5"
            value={form.description}
            onChange={handleChange}
            placeholder="Tadbir haqida qo‘shimcha ma’lumot..."
          />
        </div>

        {/* Tugmalar */}
        <div className="form-buttons">
          <button type="submit" className="save">
            {initialData ? "Yangilash" : "Qo‘shish"}
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default MeetingForm;